// extracted by mini-css-extract-plugin
export default {"container":"BriefArea-module__container--b556"};